import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaApertura } from "@/shared/types/caja-apertura";

export async function getCajaApertura(id: string): Promise<CajaApertura> {
    await sleep(1000);
    const response = await api.get("cajas/aperturas/" + id);
    return response.data;
}

export function useGetCajaAperturaQuery(id: string, queryConfig: QueryConfig<CajaApertura> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCajaApertura(id),
        queryKey: ["cajas", "aperturas", id],
    })
}

export interface GetCajaAperturaQueryProps {
    id: string,
    queryConfig?: QueryConfig<CajaApertura>,
    children?: (queryResult: QueryResult<CajaApertura>) => ReactNode
}

export function GetCajaAperturaQuery({
    id,
    children,
    queryConfig
}: GetCajaAperturaQueryProps) {
    const queryResult = useGetCajaAperturaQuery(id, queryConfig);
    return children && children(queryResult);
}